module.exports = __webpack_public_path__ + "static/media/print-button.84056a90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/print-button.svg
// module id = 671
// module chunks = 0